import { useQuery } from '@apollo/client';
import {
  ContactSearchProfileCardFragment,
  GetContactProfileRatingQuery,
} from '../../../generated/graphql';
import {
  getSearchResultRating,
  shouldFetchProfileRating,
} from '../../../utils/search-ratings';
import { GET_CONTACT_PROFILE_RATING } from '../../contact-profile-card/contact-search-profile-card-with-fragment';

export interface ContactRating {
  averageRating: number;
  totalReviews: number;
}

const useContactRating = (
  contact: ContactSearchProfileCardFragment,
): ContactRating | undefined => {
  const { data: profileData, loading: profileLoading } =
    useQuery<GetContactProfileRatingQuery>(GET_CONTACT_PROFILE_RATING, {
      variables: { contactId: contact.id },
      skip: !contact.id || !shouldFetchProfileRating(contact.profileTier),
    });

  const { rating, totalReviews } =
    getSearchResultRating({
      searchRecentReviewCount: contact.reputation?.numberOfReviewsRecent,
      profileRating:
        profileData?.contactByContactId?.recommendations?.overallStarRating,
      profileReviewCount:
        profileData?.contactByContactId?.recommendations?.numberOfReviews,
      profileLoading,
      profileTier: contact.profileTier,
      depthTier: profileData?.contactByContactId?.depthTier,
    }) ?? {};

  if (rating === undefined || totalReviews === undefined) {
    return undefined;
  }

  return { averageRating: rating, totalReviews };
};

export default useContactRating;
